import { motion } from 'framer-motion';
import { startUsingSteps } from '../../../../../data/landingPage/landingPageData';

const StepperProcessCard = () => {
  const steps = startUsingSteps;

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="flex-[2] bg-white rounded-3xl p-5 sm:p-8 border-t-[6px] border-t-[#067978] border border-gray-100 flex flex-col items-center shadow-[0_4px_20px_rgba(6,121,120,0.03)]"
    >
      <h2 className="text-xl md:text-2xl font-bold text-[#1a2b49] tracking-tight mb-8 sm:mb-12 text-center">
        Start using Trrip in minutes
      </h2>

      {/* Desktop Horizontal Stepper (md and up) */}
      <div className="hidden md:flex relative w-full max-w-4xl mx-auto justify-between items-start">
        <div className="absolute top-[14px] left-[10%] right-[10%] h-[2px] bg-gray-200 z-0" />

        {steps.map((step, idx) => (
          <div key={idx} className="relative z-10 flex flex-col items-center w-1/5 group">
            <div className="w-7 h-7 rounded-full bg-[#067978] text-white flex items-center justify-center text-sm font-semibold mb-4 shadow-sm group-hover:scale-110 transition-transform">
              {step.num}
            </div>
            <p className="text-center text-[#475569] font-normal text-[11px] md:text-xs leading-tight h-10 mb-4 px-1">
              {step.text}
            </p>
            <div className="w-14 h-14 rounded-2xl bg-white flex items-center justify-center shadow-sm border border-gray-100 group-hover:shadow-md group-hover:-translate-y-1 transition-all">
              {step.icon}
            </div>
          </div>
        ))}
      </div>

      {/* Mobile Responsive Grid Stepper (< md) */}
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 w-full md:hidden">
        {steps.map((step, idx) => (
          <div
            key={idx}
            className={`bg-gray-50/80 rounded-2xl p-4 flex flex-col items-center text-center relative border border-gray-100 ${
              idx === 4 ? 'col-span-2 sm:col-span-1' : ''
            }`}
          >
            <div className="w-6 h-6 rounded-full bg-[#067978] text-white flex items-center justify-center text-xs font-bold mb-2 shadow-xs">
              {step.num}
            </div>
            <div className="w-11 h-11 rounded-xl bg-white flex items-center justify-center shadow-xs border border-gray-100 mb-2">
              {step.icon}
            </div>
            <p className="text-[#475569] font-medium text-xs leading-snug">{step.text}</p>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default StepperProcessCard;
